import Login from '../pages/Login' //登录
import Dom from '../pages/Dom' //例子
import Layout from '../layouts/layouts.vue' //第三级别布局
import Errorpage from '../pages/404' // 404
import System from '../layouts/system.vue' // 第二级
import UserConsole from '../pages/UserConsole' //用户控制台
import UseUnits from '../pages/useUnits' //使用单位
import ProjectManagement from '../pages/ProjectManagement' //项目管理
import MaintenanceWorkOrder from '../pages/MaintenanceWorkOrder' //维保工单
import MaintenancePlan from '../pages/MaintenancePlan' //维保工单
import MaintenanceDetail from '../pages/MaintenanceDetail' //维保详情
// import MaintenanceSheet from '../pages/MaintenanceSheet' //保养单
import MaintenanceItems from '../pages/MaintenanceItems' //保养项
import MaintenanceTemplate from '../pages/MaintenanceTemplate' //保养模版
import MaintenanceLocation from '../pages/MaintenanceLocation' //保养部位

import ElevatorManagement from '../pages/ElevatorManagement' //电梯管理
import DepartmentManagement from '../pages/DepartmentManagement' //部门管理
import UserManagement from '../pages/UserManagement' //用户管理
import TaskAssigned from '../pages/TaskAssigned' // 任务指派

import ContractManagement from '../pages/ContractManagement' // 合同管理
import ContractAdd from '../pages/ContractManagement/components/ContractAdd.vue' //合同添加
import ContractReceivables from '../pages/ContractReceivables' //合同应收款
import MaintenanceFeeConfirmation from '../pages/MaintenanceFeeConfirmation' //维修费确认
import MaintenanceFeeCollected from '../pages/MaintenanceFeeCollected' //维修费待收
import GeneralIedger from '../pages/GeneralIedger' //收费总账

import CustomerManagement from '../pages/CustomerManagement' //客户管理

import MaterialManagement from '../pages/MaterialManagement' //材料管理

// 维修管理
import FaultCause from '../pages/FaultCause' //故障原因
import RecoveryWorkOrder from '../pages/RecoveryWorkOrder' //维修工单
import FaultTypesTemplate from '../pages/FaultTypesTemplate' //故障类型模板
import FaultTypesItems from '../pages/FaultTypesItems' //故障类型
import RecoveryWorkOrderCost from '../pages/RecoveryWorkOrderCost' //维修费提成
import CustomerFollowManagement from '../pages/CustomerFollowManagement'
import WxTemplatePushManagement from '../pages/WxTemplatePushManagement'
import Dom2 from '../pages/Dom2'
import Index from '../pages/Index'

// 技术文档管理
import TechnologyDocument from '../pages/TechnologyDocument'

// 年检管理
import AnnualInspection from '../pages/AnnualInspection'
import PayableManagement from "../pages/PayableManagement" //付款单据
import CarManagement from "../pages/CarManagement" //车辆单据
import CardManagement from "../pages/CardManagement" //银行卡单据

import ReceiveManagement from "../pages/ReceiveManagement" //应收单据
import TurnoverManagement from "../pages/TurnoverManagement" //银卡卡流水
import ReceiveReminderManagement from "../pages/ReceiveReminderManagement" //应付催收
import Collect from "../pages/Collect" //

// 销售管理
import XMGL from "../pages/salesManagement/xmgl" //项目管理
import WHMB from '../pages/salesManagement/whmb' // 电销模板
import GZMB from '../pages/salesManagement/gzmb' // 跟踪模板
import DXJH from '../pages/salesManagement/dxjh' // 电销计划
import BFJL from '../pages/salesManagement/bfjl' // 拜访记录
import transferOrder from '../pages/salesManagement/transferOrder' // 交接单

const routerConfig = [{
  path: '/',
  component: System,
  children: [{
    path: '',
    name: 'Index',
    component: Index
  }]
},
{
  path: '/dom',
  redirect: 'dom/dom2',
  component: Layout,
  children: [{
    path: 'dom2',
    name: 'Dom2',
    component: Dom2
  }]
},

{
  path: '/project',
  redirect: 'project/useUnits',
  component: Layout,
  name: 'Project',
  meta: {
    title: '项目管理'
  },
  children: [{
    path: 'useUnits',
    name: 'UseUnits',
    component: UseUnits,
    meta: {
      title: '使用单位'
    },
  },
  {
    path: 'projectManagement',
    name: 'ProjectManagement',
    component: ProjectManagement,
    meta: {
      title: '项目管理'
    },
  }
  ]
},
{
  path: '/maintenance',
  redirect: 'maintenance/maintenanceWorkOrder',
  component: Layout,
  name: 'Maintenance',
  meta: {
    title: '维保管理'
  },
  children: [{
    path: 'maintenanceWorkOrder',
    name: 'MaintenanceWorkOrder',
    component: MaintenanceWorkOrder,
    meta: {
      title: '维保工单'
    },
  },
  {
    path: 'maintenancePlan',
    name: 'MaintenancePlan',
    component: MaintenancePlan,
    meta: {
      title: '维保计划'
    },
  },
  {
    path: 'maintenanceDetail',
    name: 'MaintenanceDetail',
    component: MaintenanceDetail,
    meta: {
      title: '维保详情'
    },
  },
  // {
  //   path: 'maintenanceSheet',
  //   name: 'MaintenanceSheet',
  //   component: MaintenanceSheet,
  //   meta: {
  //     title: '保养单'
  //   },
  // },
  {
    path: 'maintenanceTemplate',
    name: 'MaintenanceTemplate',
    component: MaintenanceTemplate,
    meta: {
      title: '保养模版'
    },
  },
  {
    path: 'maintenanceLocation',
    name: 'MaintenanceLocation',
    component: MaintenanceLocation,
    meta: {
      title: '保养部位'
    },
  },

  {
    path: 'maintenanceItems',
    name: 'MaintenanceItems',
    component: MaintenanceItems,
    meta: {
      title: '保养项',
      activeName: '保养模版',
      activePath: 'maintenanceTemplate',
      activePathName: 'MaintenanceTemplate'
    },
  }
  ]
},
// 电梯管理
{
  path: '/elevatorManagement',
  redirect: 'elevatorManagement/elevatorManagement',
  component: Layout,
  name: 'Elevator',
  meta: {
    title: '电梯管理'
  },
  children: [{
    path: 'elevatorManagement',
    name: 'ElevatorManagement',
    component: ElevatorManagement,
    meta: {
      title: '电梯管理'
    },
  }]
},
// 电梯管理
{
  path: '/materialManagement',
  redirect: 'materialManagement/materialManagement',
  component: Layout,
  name: 'Material',
  meta: {
    title: '材料管理'
  },
  children: [{
    path: 'materialManagement',
    name: 'MaterialManagement',
    component: MaterialManagement,
    meta: {
      title: '材料列表'
    },
  }]
},
// 用户部门
{
  path: '/userDepartment',
  redirect: 'userDepartment/departmentManagement',
  component: Layout,
  name: 'UserDepartment',
  meta: {
    title: '用户部门'
  },
  children: [{
    path: 'departmentManagement',
    name: 'DepartmentManagement',
    component: DepartmentManagement,
    meta: {
      title: '部门管理'
    },
  },
  {
    path: 'userManagement',
    name: 'UserManagement',
    component: UserManagement,
    meta: {
      title: '用户管理'
    },
  },
  {
    path: 'taskAssigned',
    name: 'TaskAssigned',
    component: TaskAssigned,
    meta: {
      title: '任务指派'
    }
  }
  ]
},
// 合同财务
{
  path: '/contractFinancial',
  redirect: 'contractFinancial/contractManagement',
  component: Layout,
  name: 'ContractFinancial',
  meta: {
    title: '合同财务'
  },
  children: [{
    path: 'contractManagement',
    name: 'ContractManagement',
    component: ContractManagement,
    meta: {
      title: '合同管理'
    },
  },
  {
    path: 'contractAdd',
    name: 'ContractAdd',
    component: ContractAdd,
    meta: {
      title: '合同添加',
      activeName: '合同管理',
      activePath: 'ContractManagement',
      activePathName: 'ContractManagement',
      noBreadCrumb: true
    },
  },
  {
    path: 'contractEdit',
    name: 'ContractEdit',
    component: ContractAdd,
    meta: {
      title: '合同编辑',
      activeName: '合同管理',
      activePath: 'contractManagement',
      activePathName: 'ContractManagement',
      noBreadCrumb: true
    },
  },
  {
    path: 'contractDetail',
    name: 'ContractDetail',
    component: ContractAdd,
    meta: {
      title: '合同查看',
      activeName: '合同管理',
      activePath: 'contractManagement',
      activePathName: 'ContractManagement',
      noBreadCrumb: true
    },
  },
  {
    path: 'contractReceivables',
    name: 'ContractReceivables',
    component: ContractReceivables,
    meta: {
      title: '合同应收款',
      activeName: '合同管理',

    },
  },
  {
    path: 'maintenanceFeeConfirmation',
    name: 'MaintenanceFeeConfirmation',
    component: MaintenanceFeeConfirmation,
    meta: {
      title: '维修费确认',

    },
  },
  {
    path: 'maintenanceFeeCollected',
    name: 'MaintenanceFeeCollected',
    component: MaintenanceFeeCollected,
    meta: {
      title: '维修费待收',

    },
  },
  {
    path: 'generalIedger',
    name: 'GeneralIedger',
    component: GeneralIedger,
    meta: {
      title: '收款总账',

    },
  },
  {
    path: 'payable',
    name: 'Payable',
    component: PayableManagement,
    meta: {
      title: '付款单据',
    },
  },
  {
    path: 'car',
    name: 'Car',
    component: CarManagement,
    meta: {
      title: '车辆管理',
    },
  },
  {
    path: 'card',
    name: 'Card',
    component: CardManagement,
    meta: {
      title: '银行卡管理',
    },
  },
  {
    path: 'receive',
    name: 'Receive',
    component: ReceiveManagement,
    meta: {
      title: '应收管理',
    },
  },
  {
    path: 'turnover',
    name: 'Turnover',
    component: TurnoverManagement,
    meta: {
      title: '银行卡流水',
    },
  },
  {
    path: 'receiveReminder',
    name: 'ReceiveReminder',
    component: ReceiveReminderManagement,
    meta: {
      title: '应付催收',
    },
  },
    {
      path: 'collect',
      name: 'Collect',
      component: Collect,
      meta: {
        title: '收支汇总',
      }
    }
  ]
},
{
  path: '/customer',
  redirect: 'customer/customerManagement',
  component: Layout,
  name: 'Customer',
  meta: {
    title: '客户管理'
  },
  children: [{
    path: 'customerManagement',
    name: 'CustomerManagement',
    component: CustomerManagement,
    meta: {
      title: '客户管理'
    },
  },
  {
    path: 'customerFollowManagement',
    name: 'CustomerFollowManagement',
    component: CustomerFollowManagement,
    meta: {
      title: '客户关注列表'
    },
  },
  {
    path: 'wxTemplatePushManagement',
    name: 'WxTemplatePushManagement',
    component: WxTemplatePushManagement,
    meta: {
      title: '微信推送列表'
    },
  },
  ]
},
{
  path: '/console',
  component: Layout,
  name: 'Console',
  redirect: 'console/userConsole',
  meta: {
    title: '控制台'
  },
  children: [{
    path: 'userConsole',
    name: 'UserConsole',
    component: UserConsole,
    meta: {
      title: '控制台',
      noBreadCrumb: true
    },
  }]
},
{
  path: '/recovery',
  redirect: 'recovery/faultCause',
  component: Layout,
  name: 'Recovery',
  meta: {
    title: '维修管理'
  },
  children: [{
    path: 'faultCause',
    name: 'FaultCause',
    component: FaultCause,
    meta: {
      title: '故障原因'
    },
  },
  {
    path: 'recoveryWorkOrder',
    name: 'recoveryWorkOrder',
    component: RecoveryWorkOrder,
    meta: {
      title: '维修工单'
    },
  },
  {
    path: 'recoveryWorkOrderCost',
    name: 'recoveryWorkOrderCost',
    component: RecoveryWorkOrderCost,
    meta: {
      title: '维修工单提成'
    },
  },
  {
    path: 'faultTypesTemplate',
    name: 'FaultTypesTemplate',
    component: FaultTypesTemplate,
    meta: {
      title: '故障类型模板'
    },
  },
  {
    path: 'faultTypesItems',
    name: 'FaultTypesItems',
    component: FaultTypesItems,
    meta: {
      title: '故障点',
      activeName: '故障类型模板',
      activePath: 'faultTypesTemplate',
      activePathName: 'FaultTypesTemplate'
    },
  }
  ]
},
{
  path: '/technology',
  redirect: 'technology/document',
  component: Layout,
  name: 'Technology',
  meta: {
    title: '技术文档管理'
  },
  children: [{
    path: 'document',
    name: 'document',
    component: TechnologyDocument,
    meta: {
      title: '技术文档管理'
    },
  },]
},
{
  path: '/annualInspection',
  redirect: 'annualInspection/njgl',
  component: Layout,
  name: 'AnnualInspection',
  meta: {
    title: '年检管理'
  },
  children: [{
    path: 'njgl',
    name: 'njgl',
    component: AnnualInspection,
    meta: {
      title: '年检管理'
    },
  },]
},
{
  path: '/salesManagement',
  redirect: 'salesManagement/xmgl',
  component: Layout,
  name: 'SalesManagement',
  meta: {
    title: '销售管理'
  },
  children: [{
    path: 'xmgl',
    name: 'SalesManagement-xmgl',
    component: XMGL,
    meta: {
      title: '项目管理'
    },
  }, {
    path: 'whmb',
    name: 'SalesManagement-whmb',
    component: WHMB,
    meta: {
      title: '电销模板'
    },
  },
  {
    path: 'gzmb',
    name: 'SalesManagement-gzmb',
    component: GZMB,
    meta: {
      title: '跟踪模板'
    },
  },
  {
    path: 'dxjh',
    name: 'SalesManagement-dxjh',
    component: DXJH,
    meta: {
      title: '电销计划'
    },
  },
  {
    path: 'bfjl',
    name: 'SalesManagement-bfjl',
    component: BFJL,
    meta: {
      title: '拜访记录'
    },
  },
  {
    path: 'transferOrder',
    name: 'SalesManagement-transferOrder',
    component: transferOrder,
    meta: {
      title: '交接单'
    },
  },
  ]
},
{
  path: '*',
  redirect: '/Errorpage'
}
]

const routerP = [{
  path: '/login',
  name: 'Login',
  component: Login
},
{
  path: '/Errorpage',
  name: 'Errorpage',
  component: Errorpage
},
]

const routes = [...routerConfig, ...routerP]

export default routes



// WEBPACK FOOTER //
// ./src/router/routerConfig.js